// Angular modules.
import { Injectable } from '@angular/core';
// RxStomp
import { RxStompService } from '@stomp/ng2-stompjs';
import { Message } from '@stomp/stompjs';
import { environment } from 'environments/environment';

// Zenklub services.
import { EventsService } from './events.service';

@Injectable()
export class WePayOutService {
	// Constructor.
	constructor(
		private events: EventsService,
		private rxStompService: RxStompService
	) {}

	public responseWePayOutValidation(userId: string): void {
		const value = environment.rabbitmq.toppics.accountValidation + userId;

		this.rxStompService.watch(value).subscribe((message: Message) => {
			this.events.verifyNewEvent(JSON.parse(message.body));
		});
	}

	public disconnect() {
		this.rxStompService.deactivate();
	}
}
